import React, { useEffect } from 'react';
import { Container, Row, Col, Card, CardBody } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import UserInfoTable from '../components/user-info/UserInfoTable';
import UserInfoNotice from '../components/user-info/UserInfoNotice';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetMessage } from '../redux/slices/user';
import { getOwnInfo } from '../redux/slices/ownInfo';

const UserInfo = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const hasError = useSelector((state: RootState) => state.ownInfo.hasError);
  const serverMessage = useSelector((state: RootState) => state.ownInfo.serverMessage);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  /**
   * 初期データを取得する
   */
  useEffect(() => {
    dispatch(getOwnInfo());
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * クローズボタンを押したとき
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('user.info')} subtitle="User Info" className="text-sm-left" />
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row>
        <Col>
          <Card small className="mb-4">
            <CardBody>
              <UserInfoTable />
              <UserInfoNotice />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UserInfo;
